module.exports = __webpack_public_path__ + "img/vn.53c9fffa.jpg";